import React, { useEffect } from 'react';
import PropdocsModal from '../../../modal/PropdocsModal';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useDocumentRole } from '../../../../shared/hooks/useDocumentRole/useDocumentRole';
import RequestReviewContainer from '../components/headerActions/requestReview/RequestReviewContainer';
import { useDocumentState } from '../../../../contexts/DocumentContext';
import { useModals } from '../../../../contexts/ModalsContext';
import { DocumentStatusEnum } from '../../../../shared/constants/document';
import styles from './pendingReviewWarningModal.module.scss';

interface PendingReviewWarningProps {
  showModal: boolean;
  hideModal: (set: boolean) => void;
  onCloseDocument: (() => void) | undefined;
  canEdit: boolean;
  dealId: string;
  teamId: string;
  documentId: string;
  dealTeamsData: any;
  onSave: (() => Promise<void>) | undefined;
  canShare: boolean;
  shouldShowInternalSendForSigning: boolean | null | undefined;
  shouldShowSendForSigning: boolean | null | undefined;
}

const PendingReviewWarningModal = ({
  showModal,
  hideModal,
  onCloseDocument,
  dealId,
  teamId,
  documentId,
  canEdit,
  dealTeamsData,
  onSave,
  canShare,
  shouldShowInternalSendForSigning,
  shouldShowSendForSigning,
}: PendingReviewWarningProps) => {
  const { isDocumentCreator } = useDocumentRole(documentId);
  const { state } = useDocumentState();
  const documentStatus = state.status;
  const isDocumentEditable = state.isEditable;
  const isDraft = documentStatus === DocumentStatusEnum.DRAFT;
  const isUploaded = documentStatus === DocumentStatusEnum.UPLOADED;
  const isShared = documentStatus === DocumentStatusEnum.SHARED;
  const isReviewing = documentStatus === DocumentStatusEnum.REVIEWING;
  const isExecuted = documentStatus === DocumentStatusEnum.EXECUTED;

  const classes = classNames(styles['pendingReviewWarningModal'], 'document-wizard-modal-custom', 'allowOverflow');

  const { closePendingReviewWarningModal: isPendingReviewModalClosed, setClosePendingWarningReviewModal } = useModals();

  useEffect(() => {
    if (isPendingReviewModalClosed) {
      setClosePendingWarningReviewModal(false);
    }
  }, [isPendingReviewModalClosed, setClosePendingWarningReviewModal]);

  return (
    <PropdocsModal
      show={showModal}
      setShow={() => hideModal(false)}
      size="md"
      className={classes}
      title={
        <header>
          <FormattedMessage id="title.warn-user-leaving-document_header" defaultMessage="Before You Go..." />
        </header>
      }
    >
      <>
        <div style={{ marginBottom: '1.5rem' }}>
          <p>
            <FormattedMessage
              id="title.warn-user-leaving-document_message"
              defaultMessage="Are you ready to send the document for review or signing?"
            />
          </p>
        </div>
        <div className={styles.modalButtonsContainer}>
          <Button
            onClick={() => {
              onCloseDocument && onCloseDocument();
            }}
            className="btn btn-secondary"
          >
            {'Not Yet'}
          </Button>
          <div className={styles.sendButtonWrapper}>
            <RequestReviewContainer
              dealTeamsData={dealTeamsData}
              documentId={documentId}
              dealId={dealId}
              handleSaveDocument={onSave}
              teamId={teamId}
              isDocumentEditable={isDocumentEditable}
              isDocumentCreator={isDocumentCreator}
              isDocumentShared={isShared}
              shouldShowInternalSendForSigning={!!shouldShowInternalSendForSigning}
              hasInviteSendingPermission={true}
              hasEditPermission={true}
              isInModal={true}
              onModalClose={() => hideModal(false)}
              isDraft={isDraft}
              isUploaded={isUploaded}
              isReviewing={isReviewing}
              isShared={isShared}
              isExecuted={isExecuted}
            />
          </div>
        </div>
      </>
    </PropdocsModal>
  );
};

export default PendingReviewWarningModal;
